export const dashboardEn = {
  dashboardCollections: 'Today\'s collections',
  dashboardVolumeToday: 'Volume today',
  dashboardSeeAll: 'See all',
  dashboardActivity: 'Recent activity',
  dashboardCashFlow: 'Cash flow',
  dashboardTicketStatus: 'Tickets by status',
  dashboardAuditSeverity: 'Audit by severity',
  dashboardHourlyVolume: 'Volume by hour',
  dashboardRecentCollections: 'Recent collections',
  ticketStatusOpen: 'Open',
  ticketStatusResolved: 'Resolved',
  ticketStatusOther: 'Other',
  rates: 'FX rates',
  exchangeRatesTitle: 'Exchange rates',
  exchangeRatesKicker: 'Informational · shared for all houses · updated 1–2× daily',
  exchangeRatesInformalTitle: 'Informal market',
  exchangeRatesInformalBadge: 'TRMI',
  exchangeRatesOfficialTitle: 'Official rates',
  exchangeRatesOfficialBadge: 'Formal',
  exchangeRatesOfficialPublicTitle: 'BCC public rate',
  exchangeRatesOfficialPublicBadge: 'Public',
  exchangeRatesOfficialSpecialTitle: 'BCC special rate',
  exchangeRatesOfficialSpecialBadge: 'Special',
  exchangeRatesUsd: 'US Dollar',
  exchangeRatesSource: 'Informal reference from',
  exchangeRatesOfficialSource: 'Formal rates from',
  exchangeRatesAsOf: 'Last update',
  exchangeRatesEmpty: 'No rates available',
  exchangeRatesEmptyHint: 'CUP rates will appear here after the next scheduled sync (1–2× per day).',
  fxCode_USD: 'US Dollar',
  fxCode_EUR: 'Euro',
  fxCode_MLC: 'MLC',
  fxCode_CAD: 'Canadian dollar',
  fxCode_MXN: 'Mexican peso',
  fxCode_ZELLE: 'Zelle',
  fxCode_CLA: 'Clasificados',
  cryptoRatesTitle: 'Crypto reference',
  cryptoRatesBadge: 'Spot',
  cryptoRatesSource: 'Reference values from',
  cryptoRatesDerivedCup: 'Approx. CUP (via informal USD)',
  cryptoRatesUpdatedAgo: 'Updated {seconds}s ago',
  cryptoRatesRefresh: 'Refresh crypto',
  cryptoRatesUnavailable: 'Could not refresh crypto quotes; showing last known values.',
  fxCode_BTC: 'Bitcoin',
  fxCode_ETH: 'Ethereum',
  fxCode_USDT: 'Tether',
  footerInterestLinks: 'Helpful links',
  footerLegalLinks: 'Legal',
  footerFaqs: 'FAQs',
  footerHelp: 'Help',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerCopyright: '© {year} Alea TUI',
  godDashboard: 'Dashboard',
  godDashboardHint: 'Platform-wide health, volume, and house status at a glance.',
  godDashboardKickerGlobal: 'All platform',
  godDashboardKickerHouse: 'Scoped house',
  godPlatformNet: 'Platform net',
  godHousesActive: 'Active houses',
  godHousesSuspended: 'Suspended',
  godHousesRoster: 'House roster',
  flagNightWindow: 'Night window enabled',
  flagNightWindowDesc: 'Allow plays after the day window closes.',
  flagParle: 'Parlé plays',
  flagParleDesc: 'Allow two-number parlé bets.',
  flagCentena: 'Centena plays',
  flagCentenaDesc: 'Allow three-digit centena bets.',
  flagAutoSchedule: 'Auto-scheduler',
  flagAutoScheduleDesc: 'Client-side cutoff notifications.',
  flagRunnerMap: 'Runner map view',
  flagRunnerMapDesc: 'GPS-optimized route display.',
  flagCharadaEnglish: 'Charada in English',
  flagCharadaEnglishDesc: 'English keywords in charada search.',
  flagMaintenanceMode: 'Maintenance mode',
  flagMaintenanceModeDesc: 'Blocks non-god roles; only platform god can operate.',
} as const;

export const dashboardEs = {
  dashboardCollections: 'Colectas del día',
  dashboardVolumeToday: 'Volumen hoy',
  dashboardSeeAll: 'Ver todo',
  dashboardActivity: 'Actividad reciente',
  dashboardCashFlow: 'Flujo de caja',
  dashboardTicketStatus: 'Tickets por estado',
  dashboardAuditSeverity: 'Audit por severidad',
  dashboardHourlyVolume: 'Volumen por hora',
  dashboardRecentCollections: 'Recogidas recientes',
  ticketStatusOpen: 'Abiertos',
  ticketStatusResolved: 'Resueltos',
  ticketStatusOther: 'Otros',
  rates: 'Tasas',
  exchangeRatesTitle: 'Tasas de cambio',
  exchangeRatesKicker: 'Informativas · mismas para todas las casas · se actualizan 1–2 veces al día',
  exchangeRatesInformalTitle: 'Mercado informal',
  exchangeRatesInformalBadge: 'TRMI',
  exchangeRatesOfficialTitle: 'Tasas oficiales',
  exchangeRatesOfficialBadge: 'Formal',
  exchangeRatesOfficialPublicTitle: 'Tasa pública BCC',
  exchangeRatesOfficialPublicBadge: 'Pública',
  exchangeRatesOfficialSpecialTitle: 'Tasa especial BCC',
  exchangeRatesOfficialSpecialBadge: 'Especial',
  exchangeRatesUsd: 'Dólar estadounidense',
  exchangeRatesSource: 'Referencia informal de',
  exchangeRatesOfficialSource: 'Tasas formales de',
  exchangeRatesAsOf: 'Última actualización',
  exchangeRatesEmpty: 'No hay tasas disponibles',
  exchangeRatesEmptyHint: 'Las tasas en CUP aparecerán aquí tras la próxima sync programada (1–2 veces al día).',
  fxCode_USD: 'Dólar estadounidense',
  fxCode_EUR: 'Euro',
  fxCode_MLC: 'MLC',
  fxCode_CAD: 'Dólar canadiense',
  fxCode_MXN: 'Peso mexicano',
  fxCode_ZELLE: 'Zelle',
  fxCode_CLA: 'Clasificados',
  cryptoRatesTitle: 'Cripto de referencia',
  cryptoRatesBadge: 'Spot',
  cryptoRatesSource: 'Valores de referencia de',
  cryptoRatesDerivedCup: 'CUP aprox. (vía USD informal)',
  cryptoRatesUpdatedAgo: 'Actualizado hace {seconds}s',
  cryptoRatesRefresh: 'Actualizar cripto',
  cryptoRatesUnavailable: 'No se pudo actualizar cripto; se muestran los últimos valores conocidos.',
  fxCode_BTC: 'Bitcoin',
  fxCode_ETH: 'Ethereum',
  fxCode_USDT: 'Tether',
  footerInterestLinks: 'Enlaces de interés',
  footerLegalLinks: 'Legal',
  footerFaqs: 'FAQs',
  footerHelp: 'Ayuda',
  footerPrivacy: 'Privacidad',
  footerTerms: 'Términos',
  footerCopyright: '© {year} Alea TUI',
  godDashboard: 'Panel',
  godDashboardHint: 'Salud de la plataforma, volumen y estado de las casas de un vistazo.',
  godDashboardKickerGlobal: 'Toda la plataforma',
  godDashboardKickerHouse: 'Casa en foco',
  godPlatformNet: 'Neto plataforma',
  godHousesActive: 'Casas activas',
  godHousesSuspended: 'Suspendidas',
  godHousesRoster: 'Bancas',
  flagNightWindow: 'Ventana nocturna',
  flagNightWindowDesc: 'Permite jugadas tras cerrar el turno diurno.',
  flagParle: 'Jugadas parlé',
  flagParleDesc: 'Permite apuestas parlé de dos números.',
  flagCentena: 'Jugadas centena',
  flagCentenaDesc: 'Permite apuestas centena de tres dígitos.',
  flagAutoSchedule: 'Auto-programador',
  flagAutoScheduleDesc: 'Avisos de cierre en el cliente.',
  flagRunnerMap: 'Mapa del recogedor',
  flagRunnerMapDesc: 'Vista de ruta optimizada con GPS.',
  flagCharadaEnglish: 'Charada en inglés',
  flagCharadaEnglishDesc: 'Palabras clave en inglés en la búsqueda de charada.',
  flagMaintenanceMode: 'Modo mantenimiento',
  flagMaintenanceModeDesc: 'Bloquea roles que no son god; solo el god de plataforma puede operar.',
} as const;
